module.exports = "/_next/static/third-parties/analytics-30f34ebc8950b3e9443e8d1eb6fe35e7.js";